import React, { useState, useEffect } from "react";
import HeaderSales from "../common/HeaderSales";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import axios from "axios";
import * as Constants from "../Constants/index";
import swal from "sweetalert";
import ResponsivePagination from "react-responsive-pagination";
import { saveAs } from "file-saver";
import Oval from "../../loader/CircleLoade";
import { useFormik } from "formik";
import Sidebar from "../common/Sidebar"; // Added Sidebar Import

export default function SalesTicketReport() {
  const [results, setResults] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [searchRecord, setSearchRecord] = useState(null);
  const [loading, setLoading] = useState(false);

  // Local state for non-date filters to match your pattern
  const [changeStatus, setChangeStatus] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const defaultFilters = {
    dateFrom: "",
    dateTo: "",
    phoneNum: "",
    changeStatus: "",
  };
  const [filterData, setFilterData] = useState(defaultFilters);

  const searchFormik = useFormik({
    initialValues: {
      dateFrom: "",
      dateTo: "",
    },
    validate: (data) => {
      let errors = {};
      return errors;
    },
    onSubmit: (data) => {
      const activeFilters = {
        dateFrom: data.dateFrom,
        dateTo: data.dateTo,
        phoneNum,
        changeStatus,
      };
      setFilterData(activeFilters);
      if (currentPage === 1) {
        salesTicketReport(activeFilters, 1);
      }
      setCurrentPage(1);
    },
  });

  useEffect(() => {
    salesTicketReport(filterData, currentPage);
  }, [currentPage]);

  const dateFormater = (dateVal) => {
    if (!dateVal) return "";
    const dateObject = new Date(dateVal);
    const year = dateObject.getFullYear();
    const month = ("0" + (dateObject.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObject.getDate()).slice(-2);
    const hours = ("0" + dateObject.getHours()).slice(-2);
    const minutes = ("0" + dateObject.getMinutes()).slice(-2);
    const seconds = ("0" + dateObject.getSeconds()).slice(-2);
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const salesTicketReport = (data, pageNo) => {
    let token = localStorage.getItem("token");

    try {
      const activeFilters = {
        dateFrom: data?.dateFrom ?? "",
        dateTo: data?.dateTo ?? "",
        phoneNum: data?.phoneNum ?? phoneNum,
        changeStatus: data?.changeStatus ?? changeStatus,
      };
      const searchFromDate =
        activeFilters.dateFrom === "" ? "" : `&start=${dateFormater(activeFilters.dateFrom)}`;
      const searchToDate =
        activeFilters.dateTo === "" ? "" : `&end=${dateFormater(activeFilters.dateTo)}`;
      const searchStatus =
        activeFilters.changeStatus === "" ? "" : `&status=${activeFilters.changeStatus}`;
      const searchMobile = activeFilters.phoneNum === "" ? "" : `&mobile=${activeFilters.phoneNum}`;

      setLoading(true);

      axios
        .get(
          Constants.baseUrl +
          `reports/raiseTicket/list?sortBy=createdDateTime&sortAsc=false${searchStatus}${searchFromDate}${searchToDate}${searchMobile}&limit=${limit}&page=${pageNo}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
          }
        )
        .then((res) => {
          if (res.status === 201) {
            if (res.data.code === 10001) {
              setResults(res.data.output.results);
              setTotalPages(res.data.output.totalPages);
              setSearchRecord(res.data.output.results);
            } else if (res.data.code === 12002) {
              setSearchRecord(null);
              setResults([]);
              setTotalPages(0);
            } else {
              swal({
                text: res.data.msg,
                icon: "error",
                timer: 2000,
                buttons: false,
              });
            }
          } else {
            swal({
              text: res.data.msg,
              icon: "error",
              timer: 2000,
              buttons: false,
            });
          }
          setLoading(false);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            setSearchRecord(null);
            setResults([]);
            setTotalPages(0);
            setLoading(false);
          } else {
            console.log(error);
            swal({
              text: "An unexpected error occurred.",
              icon: "error",
              timer: 2000,
              buttons: false,
            });
            setLoading(false);
          }
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const download = () => {
    let token = localStorage.getItem("token");

    try {
      // Use searchFormik values for dates to ensure sync
      const searchFromDate = searchFormik.values.dateFrom
        ? `&start=${dateFormater(searchFormik.values.dateFrom)}`
        : "";
      const searchToDate = searchFormik.values.dateTo
        ? `&end=${dateFormater(searchFormik.values.dateTo)}`
        : "";
      const searchMobile = phoneNum ? `&mobile=${phoneNum}` : "";
      const searchStatus = changeStatus ? `&status=${changeStatus}` : "";

      setLoading(true);

      axios
        .get(
          Constants.baseUrl +
          `reports/download/raiseTicket?${searchStatus}${searchMobile}${searchFromDate}${searchToDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          setLoading(false);
          if (res.status === 200) {
            const fileData = new Blob([res.data], { type: "text/csv" });
            saveAs(fileData, "ticketReport.csv");
          } else {
            swal({
              text: res.data.msg,
              icon: "error",
              timer: 2000,
              buttons: false,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          swal({
            text: "Download failed. Please try again.",
            icon: "error",
            timer: 2000,
            buttons: false,
          });
          console.error(error);
        });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
const handleReset=()=>{
  searchFormik.resetForm();
  setPhoneNum(defaultFilters.phoneNum);
  setChangeStatus(defaultFilters.changeStatus);
  setFilterData(defaultFilters);
  if (currentPage === 1) {
    salesTicketReport(defaultFilters, 1);
  }
  setCurrentPage(1)
}

  return (
    <>
      {loading ? <Oval /> : null}

      {/* --- SIDEBAR LAYOUT WRAPPER START --- */}
      <div
        style={{
          display: "flex",
          width: "100%",
          minHeight: "100vh",
          backgroundColor: "#f5f7fa",
        }}
      >
        {/* Sidebar Fixed Left */}
        <div style={{ flexShrink: 0 }}>
          <Sidebar />
        </div>

        {/* Content Area Resizable Right */}
        <div
          style={{
            flex: 1,
            padding: "20px",
            overflowX: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="all-single-blog rpt"
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              flex: 1,
            }}
          >
            {/* Tabs */}
            <div className="row">
              <div className="col-md-12 tab mb-20">
                <ul className="nav nav-tabs" role="tablist">
                  <li role="presentation" className="active">
                    <Link to="#Section1" role="tab" data-toggle="tab">
                      Ticket Report
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Form */}
            <form onSubmit={searchFormik.handleSubmit}>
              <div className="row clearfix mb-15">
                <div className="col-md-3 col-sm-12 col-xs-12">
                  <div className="form-group has-float-label style-two">
                    <label>From Date </label>
                    <DatePicker
                      id="dateFrom"
                      selected={
                        searchFormik.values.dateFrom
                          ? new Date(searchFormik.values.dateFrom)
                          : null
                      }
                      onChange={(date) =>
                        searchFormik.setFieldValue("dateFrom", date)
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showYearDropdown
                      showMonthDropdown
                      autoComplete="off"
                      scrollableYearDropdown
                    />
                  </div>
                </div>
                <div className="col-md-3 col-sm-12 col-xs-12">
                  <div className="form-group has-float-label style-two">
                    <label>To Date </label>
                    <DatePicker
                      id="dateTo"
                      selected={
                        searchFormik.values.dateTo
                          ? new Date(searchFormik.values.dateTo)
                          : null
                      }
                      onChange={(date) =>
                        searchFormik.setFieldValue("dateTo", date)
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showYearDropdown
                      showMonthDropdown
                      autoComplete="off"
                      scrollableYearDropdown
                      maxDate={new Date()}
                    />
                  </div>
                </div>
                <div className="col-md-3 col-sm-12 col-xs-12">
                  <div className="form-group has-float-label style-two">
                    <label>Mobile No. </label>
                    <input
                      id="mobile"
                      className="form-control"
                      type="text"
                      maxLength="10"
                      value={phoneNum}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        setPhoneNum(val);
                      }}
                      placeholder="Mobile No."
                    />
                  </div>
                </div>
                <div className="col-md-2 col-sm-12 col-xs-12">
                  <div className="form-group has-float-label style-two">
                    <label>Status</label>
                    <select
                      id="status"
                      className="form-control2"
                      value={changeStatus}
                      onChange={(e) => setChangeStatus(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="OPEN">Open</option>
                      <option value="CLOSED">Close</option>
                    </select>
                  </div>
                </div>
                {/* <div className="col-md-1 col-sm-12 col-xs-12">
                  <div className="form-group has-float-label style-two">
                    <label className="invisible" style={{ width: "100%" }}>
                      hidden
                    </label>
                    <button
                      type="submit"
                      className="btn login_btn"
                      style={{
                        backgroundColor: "#28a745",
                        color: "white",
                        width: "100%",
                      }}
                    >
                      Search
                    </button>
                  </div>
                </div> */}
                <div className="col-md-3 col-sm-12 col-xs-12">
  <div style={{ display: "flex", gap: "12px" }}>
    
    {/* Search */}
    <button
      type="submit"
      style={{
        backgroundColor: "#28a745",
        color: "#fff",
        border: "none",
        padding: "5px 18px",
        fontSize: "12px",
        borderRadius: "3px",
        cursor: "pointer",
        minWidth: "100px"
      }}
    >
      SEARCH
    </button>

    {/* Reset */}
    <button
      type="button"
      onClick={handleReset}
      style={{
        backgroundColor: "#6c757d",
        color: "#fff",
        border: "none",
        padding: "5px 18px",
        fontSize: "12px",
        borderRadius: "3px",
        cursor: "pointer",
        minWidth: "100px"
      }}
    >
      Reset
    </button>

  </div>
</div>
              </div>
            </form>

            {/* Table Container */}
            <div className="row">
              <div className="col-md-12">
                <div className="carrd1" style={{ marginTop: "20px" }}>
                  <div
                    className="card-header card-header-warning"
                    style={{
                      backgroundColor: "#28a745",
                      color: "white",
                      padding: "10px 15px",
                      borderRadius: "4px 4px 0 0",
                    }}
                  >
                    <h4
                      className="card-title"
                      style={{
                        margin: 0,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>Ticket Report </span>
                      {searchRecord === null ? (
                        ""
                      ) : (
                        <Link
                          to="#"
                          className="pull-right btn btn-sm btn-light"
                          style={{ color: "#28a745", fontWeight: "bold" }}
                          onClick={download}
                        >
                          <i className="fa fa-file-excel-o"></i> Export
                        </Link>
                      )}
                    </h4>
                  </div>
                  <div
                    className="card-body table-responsive"
                    style={{ border: "1px solid #ddd", borderTop: "none" }}
                  >
                    <table
                      className="table table-striped mb_01"
                      id="table-to-xls"
                    >
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>ZO Name</th>
                          <th>RO Name</th>
                          <th>Sales Head</th>
                          <th>SalesTeamName</th>
                          <th>SalesTeamMobile</th>
                          <th>Name</th>
                          <th>Mobile Number</th>
                          <th>State</th>
                          <th>City</th>
                          <th>Concern ID</th>
                          <th>Date Of Concern</th>
                          <th>Concern Type</th>
                          <th>Description</th>
                          <th>Concern Status</th>
                        </tr>
                      </thead>
                      {searchRecord === null ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan="15"
                              style={{
                                textAlign: "center",
                                fontSize: "16px",
                                padding: "20px",
                              }}
                            >
                              No record found!
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {results.map((item, index) => {
                            const serialNumber =
                              (currentPage - 1) * limit + index + 1;
                            const inputDate = item.createdDateTime;
                            const formattedDate = moment(
                              inputDate,
                              "DD-MM-YYYY HH:mm"
                            ).format("DD-MM-YYYY");

                            return (
                              <tr key={index}>
                                <td>{serialNumber}</td>
                                <td>{item[0]}</td>
                                <td>{item[1]}</td>
                                <td>{item[2]}</td>
                                <td>{item[3]}</td>
                                <td>{item[4]}</td>
                                <td>{item[5]}</td>
                                <td>{item[6]}</td>
                                <td>{item[7]}</td>
                                <td>{item[8]}</td>
                                <td>{item[9]}</td>
                                <td>{item[10]}</td>
                                <td>{item[11]}</td>
                                <td>{item[12]}</td>
                                <td>{item[13]}</td>
                                {/* <td>{item[14]}</td> */}
                              </tr>
                            );
                          })}
                        </tbody>
                      )}
                    </table>
                    <div
                      style={{
                        marginTop: "15px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {totalPages > 1 && (
                        <ResponsivePagination
                          current={currentPage}
                          total={totalPages}
                          onPageChange={(page) => {
                            setCurrentPage(page);
                            // Ensure pagination fetches with current filters
                            salesTicketReport(filterData, page);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
      {/* --- SIDEBAR LAYOUT WRAPPER END --- */}
    </>
  );
}
